"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.botTest.list': 'Bot Tests',
};
